import { Link } from 'react-router-dom';

const models = ["Locators", "Screws"];

const Models = () => {
    return (
        <div className="models">
            <h1>Models</h1>
            <div className="model-cards">
                {models.map(model => (
                    <div key={model} className="model-card">
                        <Link to={`/model/${model.toLowerCase()}`}>
                            <h2>{model}</h2>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};


export default Models;
